// Rótulos e cores do Indique e Ganhe (os mesmos da tela do lojista no comandas).

export const ETAPAS = {
    lead: { texto: 'Lead', cor: 'blue-grey' },
    cadastro: { texto: 'Cadastro', cor: 'orange darken-1' },
    cliente: { texto: 'Cliente', cor: 'green darken-1' },
};

export const COMISSOES = {
    aguardando: { texto: 'Aguardando', cor: 'grey', outlined: true },
    carencia: { texto: 'Em carência', cor: 'amber darken-2', dark: true },
    disponivel: { texto: 'Disponível', cor: 'green darken-1', dark: true },
    solicitada: { texto: 'Solicitada', cor: 'blue darken-1', dark: true },
    paga: { texto: 'Paga', cor: 'grey darken-1', dark: true },
    cancelada: { texto: 'Cancelada', cor: 'red darken-1', outlined: true },
};

export const SOLICITACOES = {
    aberta: { texto: 'Aberta', cor: 'blue darken-1' },
    paga: { texto: 'Paga', cor: 'grey darken-1' },
    cancelada: { texto: 'Cancelada', cor: 'red darken-1' },
};

export function opcoes(mapa) {
    return Object.keys(mapa).map(value => ({ value, text: mapa[value].texto }));
}

export function whatsappLink(numero) {
    const digitos = String(numero || '').replace(/\D/g, '');

    if (!digitos) {
        return null;
    }

    return `https://api.whatsapp.com/send?phone=${digitos.length <= 11 ? `55${digitos}` : digitos}`;
}
